import { VdsDropdownItem } from '@volt/volt-extended-components-react';

export interface DropdownItemProps<T> {
  key: string;
  value: T;
  stringValue: string;
  label: string;
  disabled?: boolean;
}

interface Props<T> {
  items: DropdownItemProps<T>[];
}

export const DropdownItems = <T,>({ items }: Props<T>) => {
  return items.map(({ key, stringValue, label, disabled }: DropdownItemProps<T>) => {
    return (
      <VdsDropdownItem
        key={key}
        value={stringValue}
        label={label}
        disabled={disabled}
        size="medium"
      />
    );
  });
};

export default DropdownItems;
